import { useAuth } from './useAuth';

export default function RoleGate({ min, children, fallback }) {
    const { hasRole } = useAuth();

    if (!hasRole(min)) {
        return fallback || null;
    }

    return children;
}